module.exports = __webpack_public_path__ + "static/media/tools-fill-in-the-blank.852ac9dc.svg";